import { connect } from 'react-redux';
import SubscriptionModal from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionModal);
